module.exports = [{"username":"alana.leite.0367118@iansg.com.br","first_name":"ALANA","last_name":"SOPHIA G DE C LEITE","email":"alana.leite.0367118@iansg.com.br","mediador":"mediador.galois","turma_set":["8a36"],"groups":["Aluno"]}]


//////////////////
// WEBPACK FOOTER
// ./script.json
// module id = UxA8
// module chunks = 1